import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { AxiosError } from 'axios';
import { API } from 'network/api';
import { MutationConfig } from 'types/request';
import { handleAxiosError } from 'utils/helpers';

type AssignAWDAgPayload = {
  cubeId: string;
  almAgronomistEmail: string;
};

const useMutateAssignAWDAg = (config?: MutationConfig) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: AssignAWDAgPayload) =>
      API.post('/cubes/assign-alm-agronomist', data),
    onSuccess: () => {
      config?.onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: ['farmer-group'],
      });
      message.success('AWD Agronomist assigned to farmer groups successfully');
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        handleAxiosError(error);
      } else {
        message.error('Fail to assign AWD Agronomist. Please try again.');
      }
    },
    onSettled: () => {
      config?.onFinish?.();
    },
  });

  return mutation;
};

export default useMutateAssignAWDAg;
